import React from 'react';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class RandomRelationsResults extends React.Component {
  players = () => {
    if (this.props.flag === "medals") {
      return (
        <React.Fragment>
          <PlayersInner
            key={1}
            label={"Девушки. Победители"}
            players={this.props.game.womanPlayersWithMedals}
            flag={""}
          />
          <PlayersInner
            key={2}
            label={"Мужчины. Победители"}
            players={this.props.game.manPlayersWithMedals}
            flag={""}
          />
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <PlayersInner
            key={1}
            label={"Девушки без медалей"}
            players={this.props.game.womanPlayersWithoutMedals}
            flag={""}
          />
          <PlayersInner
            key={2}
            label={"Мужчины без медалей"}
            players={this.props.game.manPlayersWithoutMedals}
            flag={""}
          />
        </React.Fragment>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default RandomRelationsResults;
